// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8c29937a","159":"38e11551","171":"bcef7b6b","377":"c7f7232b","388":"da545af0","453":"62f111fb","733":"87c75ee0","985":"96e43731"}[chunkId] + ".chunk.js";
};